import {TRANSFER_TRACK, TICK, DELAY, RESPONSE, STOP, BPM_CHANGED} from 'constants/clock-message-types.js';

export default superclass => class extends superclass  {
    async onTransferTrack({preset, pattern}) {
        let track = await this.sequencerEngine.loadTrackPreset(
            preset,
            undefined,
            true);

        track.pattern.changeLength(pattern.size);
        for (let stepNumber in pattern) {
            if (stepNumber === 'size') {
                continue;
            }
            track.pattern.stepBuckets[stepNumber]
                .fromJson(pattern[stepNumber]);
        }
        track.pattern.syncBuckets();
        this.sequencerEngine.updateSteps();
    }

    transferTrack(track) {
        // sends a track to the connected user
        let preset = this.sequencerEngine.getTrackPreset(track.trackNumber);
        let stepBuckets = track.pattern.stepBuckets;
        let pattern = {
            size: stepBuckets.length
        };
        for (let stepNumber in stepBuckets) {
            if (stepBuckets[stepNumber].anyOn()) {
                pattern[stepNumber] = stepBuckets[stepNumber].getJson();
            }
        }

        let json = {
            preset,
            pattern
        };

        this.peer.send(JSON.stringify({
            type: TRANSFER_TRACK,
            payload: json
        }));

        this.sequencerEngine.deleteTrack(track.trackNumber);

        // this.sequencerEngine.deleteTrack(track);
        // once received it deletes the track from this computer
    }
}
